module.exports = __webpack_public_path__ + "assets/img/vuex_dispatch.13b346d9.jpg";